import TipsComponents from './Tips.vue';

const tips = {
    install:function(Vue) {
        Vue.component('tips', TipsComponents)
    }
}

export default tips;